/* ============================================================
   PRODUCT PAGE JS
   assets/yc-product.js
   ============================================================ */
(function () {
  'use strict';

  /* ══ FIND PRODUCT SECTION ══ */
  var el = document.querySelector('.ycp[data-section-id]');
  if (!el) return;
  var sid = el.dataset.sectionId;

  /* ══ IMAGE / VIDEO CAROUSEL ══ */
  var slidesTrack = document.getElementById('ycp-slides-' + sid);
  var thumbsWrap  = document.getElementById('ycp-thumbs-' + sid);
  var totalSlides = slidesTrack ? slidesTrack.children.length : 0;
  var currentIdx  = 0;

  /* ── Video helpers ── */
  function getVideo(idx) {
    if (!slidesTrack) return null;
    var slide = slidesTrack.children[idx];
    return slide ? slide.querySelector('video') : null;
  }

  function playVideo(idx) {
    var v = getVideo(idx);
    if (!v) return;
    v.muted = true;
    v.currentTime = 0;
    var p = v.play();
    if (p && typeof p.catch === 'function') p.catch(function () {});
  }

  function pauseVideo(idx) {
    var v = getVideo(idx);
    if (v) v.pause();
  }

  /* ── Go to slide — NO autoplay ── */
  function goToSlide(idx) {
    if (!slidesTrack || totalSlides === 0) return;
    if (idx >= totalSlides) idx = totalSlides - 1;
    if (idx < 0) idx = 0;

    pauseVideo(currentIdx);
    currentIdx = idx;
    slidesTrack.style.transform = 'translateX(-' + (idx * 100) + '%)';

    if (thumbsWrap) {
      Array.from(thumbsWrap.querySelectorAll('.ycp__thumb')).forEach(function (t, i) {
        t.classList.toggle('is-active', i === idx);
      });
      var activeThumb = thumbsWrap.children[idx];
      if (activeThumb) {
        thumbsWrap.scrollLeft =
          activeThumb.offsetLeft - (thumbsWrap.offsetWidth / 2) + (activeThumb.offsetWidth / 2);
      }
    }

    updateArrows();
  }

  /* ── Arrows ── */
  var tprev = document.getElementById('ycp-tprev-' + sid);
  var tnext = document.getElementById('ycp-tnext-' + sid);

  function updateArrows() {
    if (tprev) tprev.disabled = currentIdx === 0;
    if (tnext) tnext.disabled = currentIdx === totalSlides - 1;
  }

  tprev && tprev.addEventListener('click', function () {
    goToSlide(currentIdx - 1);
    playVideo(currentIdx);
  });
  tnext && tnext.addEventListener('click', function () {
    goToSlide(currentIdx + 1);
    playVideo(currentIdx);
  });
  updateArrows();

  /* ── Thumb click ── */
  if (thumbsWrap) {
    thumbsWrap.addEventListener('click', function (e) {
      var btn = e.target.closest('.ycp__thumb');
      if (!btn) return;
      goToSlide(parseInt(btn.dataset.idx));
      playVideo(currentIdx);
    });
  }

  /* ── Touch swipe ── */
  var carousel = document.getElementById('ycp-carousel-' + sid);
  if (carousel) {
    var touchStartX = 0;
    carousel.addEventListener('touchstart', function (e) {
      touchStartX = e.touches[0].clientX;
    }, { passive: true });
    carousel.addEventListener('touchend', function (e) {
      var diff = touchStartX - e.changedTouches[0].clientX;
      if (Math.abs(diff) > 40) {
        goToSlide(diff > 0 ? currentIdx + 1 : currentIdx - 1);
        playVideo(currentIdx);
      }
    }, { passive: true });

    /* Mouse drag */
    var mouseStartX = 0;
    var mouseDown = false;
    carousel.addEventListener('mousedown', function (e) { mouseStartX = e.clientX; mouseDown = true; });
    document.addEventListener('mouseup', function (e) {
      if (!mouseDown) return;
      mouseDown = false;
      var diff = mouseStartX - e.clientX;
      if (Math.abs(diff) > 40) {
        goToSlide(diff > 0 ? currentIdx + 1 : currentIdx - 1);
        playVideo(currentIdx);
      }
    });
  }

  /* ══ QTY ══ */
  var qtyInput = document.getElementById('ycp-qty-' + sid);
  var minusBtn = document.getElementById('ycp-minus-' + sid);
  var plusBtn  = document.getElementById('ycp-plus-' + sid);
  minusBtn && minusBtn.addEventListener('click', function () {
    if (qtyInput && parseInt(qtyInput.value) > 1) qtyInput.value = parseInt(qtyInput.value) - 1;
  });
  plusBtn && plusBtn.addEventListener('click', function () {
    if (qtyInput) qtyInput.value = parseInt(qtyInput.value) + 1;
  });

  /* ══ VARIANT SELECTOR ══ */
  var variants        = window.ycpVariants || [];
  var selectedOptions = window.ycpSelectedOptions ? window.ycpSelectedOptions.slice() : [null, null, null];

  el.querySelectorAll('.ycp__opt-btn').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var pos = parseInt(btn.dataset.optionPos) - 1;
      selectedOptions[pos] = btn.dataset.value;
      btn.closest('.ycp__option-btns').querySelectorAll('.ycp__opt-btn').forEach(function (b) {
        b.classList.remove('is-active');
      });
      btn.classList.add('is-active');

      var matched = variants.find(function (v) {
        return (
          (selectedOptions[0] == null || v.option1 === selectedOptions[0]) &&
          (selectedOptions[1] == null || v.option2 === selectedOptions[1]) &&
          (selectedOptions[2] == null || v.option3 === selectedOptions[2])
        );
      });
      if (!matched) return;

      var atcBtn  = document.getElementById('ycp-atc-' + sid);
      var priceEl = document.getElementById('ycp-price-' + sid);
      var compEl  = document.getElementById('ycp-compare-' + sid);

      if (atcBtn) {
        atcBtn.dataset.vid = matched.id;
        atcBtn.disabled    = !matched.available;
        atcBtn.textContent = matched.available ? 'Add to Cart' : 'Sold Out';
      }
      if (priceEl) priceEl.textContent = fmt(matched.price);
      if (compEl) {
        if (matched.compare_at_price > matched.price) {
          compEl.textContent = fmt(matched.compare_at_price);
          compEl.style.display = '';
        } else {
          compEl.style.display = 'none';
        }
      }

      if (matched.featured_image && slidesTrack) {
        var varSrc = matched.featured_image.src.split('?')[0].split('/').pop().split('.')[0];
        Array.from(slidesTrack.querySelectorAll('.ycp__slide')).some(function (slide, i) {
          var img = slide.querySelector('img');
          if (img && img.src.indexOf(varSrc) > -1) {
            goToSlide(i);
            return true;
          }
          return false;
        });
      }
    });
  });

  function fmt(cents) {
    return '₹' + (cents / 100).toLocaleString('en-IN', { minimumFractionDigits: 0 });
  }

  /* ══ ADD TO CART ══ */
  var atcBtn = document.getElementById('ycp-atc-' + sid);
  atcBtn && atcBtn.addEventListener('click', function () {
    if (atcBtn.disabled) return;
    var vid      = parseInt(atcBtn.dataset.vid);
    var qty      = qtyInput ? parseInt(qtyInput.value) : 1;
    var original = atcBtn.textContent;
    atcBtn.textContent = 'Adding…';
    atcBtn.disabled    = true;

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: vid, quantity: qty })
    })
    .then(function (r) {
      if (!r.ok) throw new Error('failed');
      return r.json();
    })
    .then(function () {
      atcBtn.textContent = 'Added ✓';
      if (typeof window.ycOpenCart === 'function') {
        window.ycOpenCart();
      } else {
        var trigger = document.getElementById('yc-cart-open');
        if (trigger) trigger.click();
      }
      return fetch('/cart.js');
    })
    .then(function (r) { return r.json(); })
    .then(function (cart) {
      if (typeof window.ycUpdateBadge === 'function') window.ycUpdateBadge(cart.item_count);
      setTimeout(function () { atcBtn.textContent = original; atcBtn.disabled = false; }, 1500);
    })
    .catch(function () {
      atcBtn.textContent = original;
      atcBtn.disabled    = false;
    });
  });

  /* ══ PRODUCT PAGE ACCORDIONS ══ */
  document.querySelectorAll('.ycp__accord-btn').forEach(function (btn) {
    var body = btn.nextElementSibling;
    if (!body) return;

    var newBtn = btn.cloneNode(true);
    btn.parentNode.replaceChild(newBtn, btn);

    if (newBtn.getAttribute('aria-expanded') === 'true') {
      body.style.maxHeight = body.scrollHeight + 'px';
    } else {
      body.style.maxHeight = '0';
      body.style.overflow  = 'hidden';
    }

    newBtn.addEventListener('click', function () {
      var open = newBtn.getAttribute('aria-expanded') === 'true';
      document.querySelectorAll('.ycp__accord-btn').forEach(function (otherBtn) {
        if (otherBtn === newBtn) return;
        otherBtn.setAttribute('aria-expanded', 'false');
        var otherBody = otherBtn.nextElementSibling;
        if (otherBody) otherBody.style.maxHeight = '0';
      });
      newBtn.setAttribute('aria-expanded', open ? 'false' : 'true');
      body.style.maxHeight = open ? '0' : body.scrollHeight + 'px';
    });
  });

  /* ══ FAQ ACCORDIONS ══ */
  document.querySelectorAll('.yca-faq__item').forEach(function (item) {
    var btn = item.querySelector('.yca-faq__q');
    var ans = item.querySelector('.yca-faq__ans');
    if (!btn || !ans) return;

    if (item.classList.contains('is-open')) {
      ans.style.maxHeight = ans.scrollHeight + 'px';
    } else {
      ans.style.maxHeight = '0';
      ans.style.overflow  = 'hidden';
    }

    btn.addEventListener('click', function () {
      var isOpen = item.classList.contains('is-open');
      document.querySelectorAll('.yca-faq__item.is-open').forEach(function (openItem) {
        if (openItem !== item) {
          openItem.classList.remove('is-open');
          var openBtn = openItem.querySelector('.yca-faq__q');
          var openAns = openItem.querySelector('.yca-faq__ans');
          if (openBtn) openBtn.setAttribute('aria-expanded', 'false');
          if (openAns) openAns.style.maxHeight = '0';
        }
      });
      item.classList.toggle('is-open', !isOpen);
      btn.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
      ans.style.maxHeight = isOpen ? '0' : ans.scrollHeight + 'px';
    });
  });

})();